<p class="laft-form--title">Preguntas PEP</p>
<form class="laft-form" [formGroup]="pepDataForm">
  <app-section-message
    title="¿Qué es una Persona Políticamente Expuesta (PEP)?"
    text="Una PEP es alguien que ocupa o ha ocupado un cargo público importante, así como sus familiares directos o personas de confianza cercanas, en los últimos 2 años."
    type="warning"
  ></app-section-message>
  <section class="laft-form--group">
    <div class="laft-form-section-form">
      <p class="laft-form-section-form--title u-mb-4">{{ pepQuestion1 }}</p>
      <div>
        <mat-radio-group class="laft-form-radio-button" formControlName="isPEP">
          <mat-radio-button [value]="false"><span class="laft-form-option">No</span></mat-radio-button>
          <mat-radio-button [value]="true"><span class="laft-form-option">Sí</span></mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <section *ngIf="isPEP">
      <div formArrayName="pepList">
        <div class="laft-form--section-group" *ngFor="let pep of pepList.controls; let i = index" [formGroupName]="i">
          <div class="laft-form-section-grade">
            <div class="laft-form--header-section">
              <p class="laft-form-section-grade--title">Selecciona el representante legal o accionista</p>
              <img
                *ngIf="i > 0"
                style="cursor: pointer"
                width="16px"
                src="../../../../../../assets/icons/new-trash.png"
                (click)="removePep(i)"
              />
            </div>
            <div class="laft-form--family-fields">
              <app-select
                formControlName="peplegalRepresentative"
                valueField="value"
                textField="text"
                label="Selecciona"
                [options]="currentRepresentativesList"
              >
              </app-select>
            </div>
            <p class="laft-form-section-grade--title">
              Menciona sus parientes de 2do grado de consanguinidad y 2do de afinidad
            </p>
            <p style="margin-top: 8px" class="laft-form-section-grade--subtitle">
              Ejemplo: Hermano, abuela, cuñado, suegra, etc.
            </p>
            <div class="laft-form--family-fields" formArrayName="family2ndDegreeMembers">
              <div
                *ngFor="let member of getfamily2ndDegreeMembers(i).controls; let j = index"
                [formGroupName]="j"
                class="laft-form--family-field-group"
              >
                <app-input formControlName="fullName" label="Nombres y apellidos"></app-input>
                <app-input formControlName="relationship" label="Parentesco"></app-input>
              </div>
            </div>
            <button type="button" class="laft-form--family-button" (click)="add2ndDegreeMember(i)">
              Añadir
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                  fill="#0256FF"
                />
              </svg>
            </button>
          </div>
          <div class="laft-form-section-grade" style="margin-top: 24px">
            <p class="laft-form-section-grade--title">Cónyuge o conviviente (opcional)</p>
            <div class="laft-form--family-fields">
              <div>
                <app-input formControlName="partnerName" label="Nombres y apellidos"></app-input>
              </div>
            </div>
          </div>
          <div class="laft-form-section-grade">
            <p class="laft-form-section-grade--title">
              ¿Ha sido colaborador directo de la máxima autoridad en dichas instituciones?
            </p>
            <div class="laft-form-section-form--relatives">
              <mat-radio-group formControlName="hasBeenWorkingOnPublicInstitution">
                <mat-radio-button [value]="false"><span class="laft-form-option">No</span></mat-radio-button>
                <mat-radio-button [value]="true"><span class="laft-form-option">Sí</span></mat-radio-button>
              </mat-radio-group>
            </div>
            <div *ngIf="pep.get('hasBeenWorkingOnPublicInstitution')?.value" class="laft-form--family-fields">
              <div class="laft-form--family-field-group">
                <app-input formControlName="positionPartner" label="Cargo"></app-input>
                <app-input formControlName="institutionName" label="Nombre de la institución"></app-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <button
      *ngIf="isPEP && (!isPendingPepFlow || !hasSingleAirtableRepresentative)"
      type="button"
      style="margin-top: 34px"
      class="laft-form--family-button"
      (click)="addPep()"
    >
      Añadir
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
          fill="#0256FF"
        />
      </svg>
    </button>
  </section>

  <section class="laft-form--group">
    <div class="laft-form-section-form">
      <p class="laft-form-section-form--title u-mb-2">{{ pepQuestion2 }}</p>
      <span class="laft-form-section-form--description"
        >Cónyuge, conviviente o pariente hasta 2do grado de consanguinidad</span
      >
      <div class="laft-form-section-form--relatives">
        <mat-radio-group formControlName="hasPEPRelatives">
          <mat-radio-button [value]="false"><span class="laft-form-option">No</span></mat-radio-button>
          <mat-radio-button [value]="true"><span class="laft-form-option">Sí</span></mat-radio-button>
        </mat-radio-group>
      </div>
      <div *ngIf="hasPEPRelatives" class="laft-form--family-section">
        <div formArrayName="familyPepList">
          <div
            class="laft-form--section-group"
            *ngFor="let pep of familyPepList.controls; let i = index"
            [formGroupName]="i"
          >
            <div class="laft-form--header-section">
              <p class="laft-form-section-grade--title">Selecciona el representante legal o accionista</p>
              <img
                *ngIf="i > 0"
                style="cursor: pointer"
                width="16px"
                src="../../../../../../assets/icons/new-trash.png"
                (click)="removeFamilyPep(i)"
              />
            </div>
            <div class="laft-form--family-fields">
              <app-select
                formControlName="pepRelativeslegalRepresentative"
                valueField="value"
                textField="text"
                label="Selecciona"
                [options]="currentRepresentativesList"
              >
              </app-select>
            </div>
            <p class="laft-form--family-title">Menciona sus familiares e indica parentesco</p>
            <div class="laft-form--family-fields" formArrayName="familyMembers">
              <div
                *ngFor="let member of getFamilyMembers(i).controls; let j = index"
                [formGroupName]="j"
                class="laft-form--family-field-group"
              >
                <app-input formControlName="fullName" label="Nombres y apellidos"></app-input>
                <app-input formControlName="relationship" label="Parentesco"></app-input>
              </div>
            </div>
            <button type="button" class="laft-form--family-button" (click)="addFamilyMember(i)">
              Añadir
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                  fill="#0256FF"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <button
        *ngIf="hasPEPRelatives && (!isPendingPepFlow || !hasSingleAirtableRepresentative)"
        type="button"
        style="margin-top: 34px"
        class="laft-form--family-button"
        (click)="addFamilyPep()"
      >
        Añadir
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
            fill="#0256FF"
          />
        </svg>
      </button>
    </div>
  </section>
  <div class="laft-form--actions">
    <button type="button" class="laft-form--btn-submit" (click)="onContinue()">Continuar</button>
  </div>
</form>
